import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';

const SubscriptionExpired = () => {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card border-0 shadow-lg rounded-3 overflow-hidden">
              <div className="card-body p-4 p-md-5">
                {/* Alert icon */}
                <div className="text-center mb-4">
                  <div className="d-inline-flex align-items-center justify-content-center bg-danger bg-opacity-10 rounded-circle p-4">
                    <WarningAmberIcon style={{ fontSize: 40, color: '#d32f2f' }} />
                  </div>
                </div>

                {/* Title */}
                <div className="text-center mb-4">
                  <h3 className="fw-bold mb-2 text-danger">Subscription Expired</h3>
                  <div className="d-flex align-items-center justify-content-center gap-2 text-muted">
                    <AccessTimeIcon fontSize="small" />
                    <small>Account access suspended</small>
                  </div>
                </div>

                {/* Message */}
                <div className="text-center mb-4">
                  <p className="text-muted fs-5 lh-base mb-3">
                    Your subscription has expired and your account access has been suspended.
                  </p>

                  <div className="p-3 rounded border border-danger border-opacity-25 bg-danger bg-opacity-10">
                    <p className="small fw-medium mb-0 text-danger">
                      Please contact our support team to renew your subscription and restore access to your account.
                    </p>
                  </div>
                </div>

                {/* Support info */}
                <div className="p-3 mb-4 rounded text-center bg-light">
                  <h6 className="fw-semibold mb-3">Need Help?</h6>
                  <p className="small text-muted mb-2">Contact our support team for subscription renewal</p>
                  <code className="bg-white border rounded px-2 py-1 d-inline-block">support@samwad.com</code>
                </div>

                {/* Action button */}
                <div className="text-center pb-4">
                  <Link
                    to="/login"
                    className="login-btn btn text-decoration-none base-color-bg text-white px-5 fw-semibold"
                  >
                    <ArrowBackIcon className="me-2" />
                    Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
